import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const CardDetailContext = createContext();

export const CardDetailProvider = ({ children }) => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
  };
  axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
  const [logo, setLogo] = useState(null);

  // Get the objectId from localStorage
  const objectId = localStorage.getItem("objectId");

  // Load initial state from localStorage or set defaults
  const loadState = (key, defaultState) => {
    const storedState = localStorage.getItem(key);
    return storedState ? JSON.parse(storedState) : defaultState;
  };

  const [cardDetails, setCardDetails] = useState(
    loadState("cardDetails", {
      User_ID: objectId,
      CardType: "Personal",
      CardName: "",
      employee_id: "",
      company_id: "",
      profession_department: "",
      profession_id: "",
      professional_email_id: "",
      company_website: "",
      is_professional_verified: false,
      professional_details_status: "",
      student_id: "",
      student_email_id: "",
      student_year: "",
      student_ending_year: "",
      start_year: "",
      end_year: "",
      student_currently_pursuing: false,
      education_level: "",
      institute: "",
      institute_domain: "",
      board: "",
      degree: "",
      field_of_study: "",
      grade: "",
      institute_website: "",
      university_website: "",
      is_student_verified: false,
      student_details_status: "",
      prefix: "",
      suffix: "",
      title: "",
      nickname: "",
      summary: "",
      designation: "",
      company: "",
      profession_department: "",
      profile_pic: "",
      logo: "",
      additionalFields: {},
      DOB: "",
      card_id: "",
      role_title: "",
      details: "",
      is_experience_current: false,
      employee_type: "",
      location_type: "",
      location: "",
      responsibility: [],
      profile_headline: "",
    })
  );

  const [CardStyles, setCardStyles] = useState(
    loadState("CardStyles", {
      User_ID: objectId,
      CardType: "Professional",
      font: "",
      size: "",
      style: "",
      colorPrimary: "",
      colorSecondary: "",
      colorTitle: "",
      colorLayout: "",
      bgColor: "#ffffff",
      imageExtract: null,
      layoutStyle: "1",
    })
  );

  const [CardQrStyles, setCardQrStyles] = useState(
    loadState("CardQrStyles", {
      User_ID: objectId,
      CardType: "Professional",
      eyeBall: "",
      eyeBallcolor: "",
      eyeFrame: "",
      eyeFrameColor: "",
      qrPattern: "",
      qrPatterncolor: "#121212",
      border: "",
      bordercolor: "",
      addbg: "",
      addbgcolor: "#ede8e8",
    })
  );

  const [ContactStyles, setContactStyles] = useState(
    loadState("ContactStyles", {
      card_type: "",
      reference_id: "",
      location: "",
      mobile_number: "",
      call_visible: true,
      sms_visible: true,
      email: "",
      email_visible: true,
      whatsapp: "",
      whatsapp_visible: true,
      address: "",
      state: "",
      postal_code: "",
      city: "",
      country: "",
      is_public: true,
    })
  );

  const [SocialLinks, setSocialLinks] = useState(
    loadState("SocialLinks", {
      user_ref_id: objectId,
      card_type: "",
      links: [
        { network: "linkedin", url: "", visible: true },
        { network: "facebook", url: "", visible: true },
        { network: "instagram", url: "", visible: true },
      ],
    })
  );

  const [socialLinkShow, setSocialLinkShow] = useState(
    loadState("SocialLinks", {
      user_ref_id: objectId,
      card_type: "Professional",
      links: [
        { network: "linkedin", url: "", visible: true },
        { network: "facebook", url: "", visible: true },
        { network: "instagram", url: "", visible: true },
      ],
    })
  );

  const [AttachDocs, setAttachDocs] = useState(
    loadState("AttachDocs", {
      user_ref_id: "",
      card_id: null,
      card_name: "",
      images: [],
      videos: [],
      others: [],
    })
  );

  const updateAttachDocsVal = ({ fieldName, value }) => {
    setAttachDocs((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
  };

  // Save state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("cardDetails", JSON.stringify(cardDetails));
  }, [cardDetails]);

  useEffect(() => {
    localStorage.setItem("CardStyles", JSON.stringify(CardStyles));
  }, [CardStyles]);

  useEffect(() => {
    localStorage.setItem("CardQrStyles", JSON.stringify(CardQrStyles));
  }, [CardQrStyles]);

  useEffect(() => {
    localStorage.setItem("ContactStyles", JSON.stringify(ContactStyles));
  }, [ContactStyles]);

  useEffect(() => {
    localStorage.setItem("SocialLinks", JSON.stringify(SocialLinks));
  }, [SocialLinks]);

  useEffect(() => {
    localStorage.setItem("AttachDocs", JSON.stringify(AttachDocs));
  }, [AttachDocs]);

  const updateCardDetails = (updatedDetails) => {
    setCardDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const updateCardStyles = (updatedCardStyles) => {
    setCardStyles((prevStyles) => ({
      ...prevStyles,
      ...updatedCardStyles,
    }));
  };

  const updateCardQrStyles = (updatedCardQrStyles) => {
    setCardQrStyles((prevqrStyles) => ({
      ...prevqrStyles,
      ...updatedCardQrStyles,
    }));
  };

  const updateContactStyles = (updatedContactStyles) => {
    setContactStyles((prevContactStyles) => ({
      ...prevContactStyles,
      ...updatedContactStyles,
    }));
  };

  const updateSocialLinks = (network, updates) => {
    setSocialLinks((prevSocialLinks) => {
      const existingLink = prevSocialLinks.links.find(
        (link) => link.network === network
      );
      if (existingLink) {
        return {
          ...prevSocialLinks,
          links: prevSocialLinks.links.map((link) =>
            link.network === network ? { ...link, ...updates } : link
          ),
        };
      } else {
        return {
          ...prevSocialLinks,
          links: [...prevSocialLinks.links, { network, ...updates }],
        };
      }
    });
  };

  const updateSocialLinks2 = (updateddata) => {
    if (socialLinkShow) {
      setSocialLinks((prevSocialLinks) => ({
        ...prevSocialLinks,
        ...updateddata,
      }));
    }
  };

  const deleteSocialLink = (network) => {
    setSocialLinks((prevSocialLinks) => ({
      ...prevSocialLinks,
      links: prevSocialLinks.links.filter((link) => link.network !== network),
    }));
  };

  const updateAttachDocs = (file, type) => {
    const fileId = uuidv4();
    setAttachDocs((prevFiles) => ({
      ...prevFiles,
      [type]: [
        ...prevFiles[type],
        { ...file, fileId, showQR: false, visible: true },
      ],
    }));
  };

  const toggleQR = (fileCat, fileId) => {
    setAttachDocs((prevDocs) => ({
      ...prevDocs,
      [fileCat]: prevDocs[fileCat].map((file) =>
        file.fileId === fileId ? { ...file, showQR: !file.showQR } : file
      ),
    }));
  };

  const toggleVisibility = (fileCat, fileId) => {
    setAttachDocs((prevDocs) => ({
      ...prevDocs,
      [fileCat]: prevDocs[fileCat].map((file) =>
        file.fileId === fileId ? { ...file, visible: !file.visible } : file
      ),
    }));
  };

  const removeAttachDoc = (fileCat, fileId) => {
    setAttachDocs((prevDocs) => ({
      ...prevDocs,
      [fileCat]: (prevDocs[fileCat] || []).filter(
        (file) => file.fileId !== fileId
      ),
    }));
  };

  return (
    <CardDetailContext.Provider
      value={{
        cardDetails,
        setCardDetails,
        updateCardDetails,
        CardStyles,
        setCardStyles,
        updateCardStyles,
        CardQrStyles,
        setCardQrStyles,
        updateCardQrStyles,
        logo,
        setLogo,
        ContactStyles,
        setContactStyles,
        updateContactStyles,
        SocialLinks,
        setSocialLinks,
        updateSocialLinks,
        deleteSocialLink,
        updateSocialLinks2,
        AttachDocs,
        setAttachDocs,
        updateAttachDocs,
        updateAttachDocsVal,
        toggleQR,
        removeAttachDoc,
        toggleVisibility,
        setSocialLinkShow,
        socialLinkShow,
      }}
    >
      {children}
    </CardDetailContext.Provider>
  );
};

// Custom hook to consume the card detail context
export const useCardDetailContext = () => useContext(CardDetailContext);
